export const firebaseConfig = {
  apiKey: "AIzaSyCkZ75A7yZjrWuCevmcD2ITlHTyg1iKf60",
  authDomain: "artimber-prod.firebaseapp.com",
  projectId: "artimber-prod",
  storageBucket: "artimber-prod.appspot.com",
  messagingSenderId: "1068762291149",
  appId: "1:1068762291149:web:9e2ac2b85a9eb0da81c284",
  measurementId: "G-DEM71W02TC",
};
